var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:({ width: _vm.width }),attrs:{"id":"input-interface"}},[_c('div',{staticClass:"ii-image"},[_c('img',{attrs:{"src":_vm.image,"width":"20"}})]),_c('div',{staticClass:"ii-value"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }